<div class="file-viewer">
  <section *ngIf="showSnapshotFile"  class="file-viewer">
      <gen-file-viewer
                       [fileResourceId]="selectedEventFile"
      >
      </gen-file-viewer>
  </section></div>
